import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "../css/relatorioProjetos.css"; // Importação do CSS

function RelatorioProjetos() {
  const { id } = useParams();
  const navigate = useNavigate();
  
  const [relatorio, setRelatorio] = useState("");
  const [dataRelatorio, setDataRelatorio] = useState("");
  const [status, setStatus] = useState("");
  const [etapa, setEtapa] = useState("");
  const [loading, setLoading] = useState(false); // Adicionei loading para dar feedback no botão

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!etapa) {
      alert("Selecione a etapa antes de enviar o relatório!");
      return;
    }

    setLoading(true); // Ativa loading

    try {
      const token = localStorage.getItem("Token");
      if (!token) {
        alert("Usuário não autenticado");
        setLoading(false);
        return;
      }

      const novoRelatorio = {
        projeto_id: id,
        etapa: etapa,
        situacao_etapa: status,
        observacao: relatorio,
        data_obs: dataRelatorio,
      };

      const response = await axios.post(
        "/api/relatorios",
        novoRelatorio,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.Status === "Success") {
        alert("Relatório enviado com sucesso!");
        setRelatorio("");
        setDataRelatorio("");
        setStatus("");
        setEtapa("");
        navigate(`/viewprojetocompleto/${id}`);
      } else {
        alert("Erro ao enviar relatório");
      }
    } catch (err) {
      console.error(err);
      alert("Erro no envio do relatório");
    } finally {
      setLoading(false); // Desativa loading
    }
  };

  return (
    <div className="report-page-container">
      <div className="report-form-card">
        
        <h2 className="report-title">Novo Relatório <small style={{fontSize:'0.6em', color:'#999'}}>(ID: {id})</small></h2>
        
        <form onSubmit={handleSubmit}>
          
          {/* Etapa */}
          <div className="form-group">
            <label htmlFor="etapa" className="form-label">Etapa do Projeto</label>
            <select
              id="etapa"
              className="form-control-custom"
              value={etapa}
              onChange={(e) => setEtapa(e.target.value)}
            >
              <option value="" disabled hidden>Selecione a etapa...</option>
              <option value="1 - Estruturação do projeto">1 - Estruturação do projeto</option>
              <option value="2 - Elaboração do projeto e orçamento">2 - Elaboração do projeto e orçamento</option>
              <option value="3 - Processo licitatório">3 - Processo licitatório</option>
              <option value="4 - Assinatura do contrato">4 - Assinatura do contrato</option>
              <option value="5 - Acompanhamento contratual">5 - Acompanhamento contratual</option>
              <option value="6 - Prestação de contas e lições aprendidas">6 - Prestação de contas e lições aprendidas</option>
            </select>
          </div>

          {/* Situação e Data (Lado a Lado para economizar espaço vertical) */}
          <div className="row">
            <div className="col-md-6 form-group">
              <label htmlFor="status" className="form-label">Situação do Prazo</label>
              <select
                id="status"
                className="form-control-custom"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="" disabled hidden>Selecione...</option>
                <option value="em-andamento">Em andamento</option>
                <option value="atrasado">Atrasado</option>
                <option value="concluido-prazo">Concluído no prazo</option>
                <option value="concluido-fora-prazo">Concluído fora do prazo</option>
              </select>
            </div>

            <div className="col-md-6 form-group">
              <label htmlFor="data_relatorio" className="form-label">Data de Referência</label>
              <input
                type="date"
                id="data_relatorio"
                className="form-control-custom"
                value={dataRelatorio}
                onChange={(e) => setDataRelatorio(e.target.value)}
              />
            </div>
          </div>

          {/* Relatório (Textarea) */}
          <div className="form-group">
            <label htmlFor="relatorio" className="form-label">Observações / Detalhes</label>
            <textarea
              id="relatorio"
              className="form-control-custom"
              placeholder="Descreva o andamento desta etapa..."
              value={relatorio}
              onChange={(e) => setRelatorio(e.target.value)}
            />
          </div>

          <button type="submit" className="btn-submit" disabled={loading}>
            {loading ? "Enviando..." : "Salvar Relatório"}
          </button>
          
          {/* Botão de Cancelar opcional, caso queira voltar sem salvar */}
          <button 
            type="button" 
            className="btn btn-link text-muted w-100 mt-2 text-decoration-none"
            onClick={() => navigate(-1)}
          >
            Cancelar
          </button>

        </form>
      </div>
    </div>
  );
}

export default RelatorioProjetos;